export default {
    isExperientialCourse(state){
        return [108,121,122,123,124,126,125].includes(state.lesson_type);
    }
}


// WEBPACK FOOTER //
// ./src/store/getters.js